export type NavItem = {
    label: string;
    href: string;
    badgeKey?: string;
    badgeValue?: number;
};

export type NavVariant = 'home' | 'legal' | 'enrollment-basic' | 'client' | 'admin' | 'basic';

export type NavConfig = {
    showTabs: boolean;
    showTabsOnMobile: boolean;
    showNavItemsInMenu: boolean;
    tabsAlign: 'left' | 'center';
    showBackButton: boolean;
};

export const HOME_NAV_ITEMS: NavItem[] = [
    { label: 'O nas', href: '#o_nas' },
    { label: 'Korepetycje', href: '#korepetycje' },
    { label: 'Kursy', href: '#kursy' },
    { label: 'Cennik', href: '#cennik' },
    { label: 'FAQ', href: '#faq' },
    { label: 'Placówki', href: '#placowki' },
    { label: 'Kontakt', href: '#kontakt' },
];

export const ADMIN_NAV_ITEMS: NavItem[] = [
    { label: 'Terminy', href: '/admin/terminy' },
    { label: 'Rezerwacje', href: '/admin/rezerwacje', badgeKey: 'reservations' },
    { label: 'Grafik', href: '/admin/grafik' },
    { label: 'Klienci', href: '/admin/klienci' },
    { label: 'Zgłoszenia', href: '/admin/zgłoszenia', badgeKey: 'leads' },
    { label: 'Korepetytorzy', href: '/admin/korepetytorzy' },
    { label: 'Oferta', href: '/admin/oferta' },
    { label: 'Szablony maili', href: '/admin/szablony-maili' },
    { label: 'Ustawienia', href: '/admin/ustawienia' },
];

export const CLIENT_NAV_ITEMS: NavItem[] = [
    { label: 'Lekcje bieżące', href: '/panel/lekcje' },
    { label: 'Twoje dane', href: '/panel/konto' },
    // { label: 'Regulaminy', href: '/panel/regulaminy' },
];

export const getVariantConfig = (variant: NavVariant): NavConfig => {
    switch (variant) {
        case 'home':
            return { showTabs: true, showTabsOnMobile: false, showNavItemsInMenu: true, tabsAlign: 'center', showBackButton: false };
        case 'legal':
        case 'enrollment-basic':
            return { showTabs: false, showTabsOnMobile: false, showNavItemsInMenu: true, tabsAlign: 'center', showBackButton: true };
        case 'client':
            return { showTabs: true, showTabsOnMobile: true, showNavItemsInMenu: false, tabsAlign: 'left', showBackButton: false };
        case 'admin':
            return { showTabs: true, showTabsOnMobile: false, showNavItemsInMenu: true, tabsAlign: 'left', showBackButton: false };
        default:
            return { showTabs: false, showTabsOnMobile: false, showNavItemsInMenu: true, tabsAlign: 'center', showBackButton: true };
    }
};

export const getNavItems = ({ isAdmin, pathname, badgeCounts }: { isAdmin: boolean; pathname: string; badgeCounts?: Record<string, number> }): NavItem[] => {
    const items = pathname.startsWith('/admin')
        ? ADMIN_NAV_ITEMS
        : pathname.startsWith('/panel')
            ? CLIENT_NAV_ITEMS
            : pathname === '/'
                ? HOME_NAV_ITEMS
                : [];

    return items.map((item) => {
        if (!item.badgeKey) return item;

        const badgeValue = badgeCounts?.[item.badgeKey];
        if (!badgeValue || badgeValue <= 0) {
            return { ...item, badgeValue: undefined };
        }

        return {
            ...item,
            badgeValue,
        };
    });
};

export const getActiveTab = ({ navItems, pathname, hash }: { navItems: NavItem[]; pathname: string; hash: string }): string => {
    if (!navItems.length) return '';

    const routeMatch = navItems.find((item) => item.href.startsWith('/') && pathname.startsWith(item.href));
    if (routeMatch) return routeMatch.href;

    const hashMatch = navItems.find(
        (item) => item.href.startsWith('#') && (hash === item.href || (pathname === '/' && hash === item.href)),
    );
    if (hashMatch) return hashMatch.href;

    return '';
};
